import createTheme from './createTheme'
import { base } from './mutuamas'

const theme = {
  ...base,
}

theme.fontFamily = [
  '-apple-system, system-ui',
  '-apple-system, system-ui',
  '-apple-system, system-ui',
  'opensans',
]

theme.font = {
  ...theme.font,
  weights: {
    extralight: 200,
    light: 300,
    regular: 400,
    medium: 700, // Book
    book: 500, // Medium
    bold: 900,
    black: 1000,
  },
  sizes: {
    xxxxLarge: '50px',
    xxxLarge: '44px',
    xxLarge: '26px',
    xLarge: '20px',
    large: '18px',
    medium: '16px',
    small: '12px',
    xSmall: '11px',
    xxSmall: '11px',
    xxxSmall: '10px',
  },
}

theme.components = {
  ...theme.components,
  button: {
    ...theme.components.button,
    fontSize: 'medium',
    minHeight: '48px',
  },
  input: {
    ...theme.components.input,
    fontSize: 'medium',
    labelFontSize: 'small',
    labelFontWeight: 'regular',
  },
  paginatorButton: {
    backgroundColor: 'accent',
    borderColor: 'accent',
    borderRadius: '20px',
    enabledBorderColor: 'transparent',
  },
  table: {
    headerBackgroundColor: 'accent10',
    accent: 'accent',
  },
}

export default createTheme(theme)
